import { isTruthy } from '@ardoq/common-helpers';
import { measureNodeLabel } from '@ardoq/graph-labeling';
import type { GraphEdgeBase } from '@ardoq/graph';
import { wrapString } from 'tabview/blocks/misc/string';
import { MODERNIZED_BLOCK_DIAGRAM_EDGE_LABEL_MAX_WIDTH as MAX_WIDTH } from 'yfilesExtensions/styles/consts';
import { MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES } from 'yfilesExtensions/styles/modernized/consts';

/** @returns a map of the edge ids and their wrapped labels */
const edgeLabels = (edgesSource: GraphEdgeBase[]) =>
  new Map(
    edgesSource
      .map((edge): [string, string[]] | null => {
        const { id } = edge;
        const itemLabels = edge.getItemLabels();
        if (!itemLabels?.mainLabel) {
          return null;
        }
        const { mainLabel } = itemLabels;
        return [
          id,
          wrapString(mainLabel, MAX_WIDTH, measureNodeLabel, MAX_LINES),
        ];
      })
      .filter(isTruthy)
  );

export { edgeLabels };
